export enum MenuSuffixType {
	UPLOADED_FILES_FROM_PATIENTS = 'uploadedFilesFromPatients',
	ASSIGNED_CASES = 'assignedCases',
	WORKPLACE_CASES = 'workplaceCases',
	SIGNIFICANT_RISK_OF_SUICIDE = 'significantRiskOfSuicide',
	SIGNIFICANT_RISK_OF_MENTAL_DECOMPENSATION = 'significantRiskOfMentalDecompensation',
	LATAM_DIABETES_ENTRY_QUESTIONNAIRE = 'latamDiabetesEntryQuestionnaire',
	ALL_UNSEEN_QUESTIONNAIRE = 'allUnseenQuestionnaire',
}
